import {
  CLIENT_CHANNEL_HEADER,
  MAIN_WEB_APP_CHANNEL,
  type ClientChannel,
} from '../models/ClientChannel';

type HeaderBag =
  | {
      [key: string]: unknown;
      set?: (name: string, value: string) => void;
    }
  | undefined
  | null;

/**
 * Apply `X-Channel` for the main web app. Safe to call on every request;
 * does not block or validate beyond setting the canonical value.
 */
export function applyClientChannelHeader(
  headers: HeaderBag,
  channel: ClientChannel = MAIN_WEB_APP_CHANNEL,
): void {
  if (!headers) return;
  if (typeof headers.set === 'function') {
    headers.set(CLIENT_CHANNEL_HEADER, channel);
  } else {
    headers[CLIENT_CHANNEL_HEADER] = channel;
  }
}
